import * as React from "react";
const SvgSendOutlinedIcon = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 21, height: 20, fill: "none", viewBox: "0 0 21 20", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.542 2.5a.563.563 0 0 0-.5.774L5.767 10l-2.727 6.726a.563.563 0 0 0 .773.714l13.875-6.937a.562.562 0 0 0 0-1.007L3.814 2.56a.56.56 0 0 0-.272-.059m1.102 1.732L16.18 10 4.644 15.768l2.11-5.206h5.059a.562.562 0 1 0 0-1.125H6.755z" }));
export default SvgSendOutlinedIcon;
